import { Button } from '@mui/material';
import React, { MouseEventHandler } from 'react';
import InfoComponent from './InfoComponent';

const CustomButton: React.FC<{
   type?: "submit" | "reset" | "button" | undefined;
    disabled: boolean; 
    lable: string; 
    infoContent: string; size?: 'small' | 'medium' | 'large';
    onClick?: MouseEventHandler | undefined;
   }> = ({ type, disabled, lable, infoContent, size = 'small',onClick }) => {
  return (
    <InfoComponent infoContent={infoContent} >
      <Button onClick={onClick} type={type} disabled={disabled} variant="contained" color="primary" size={size} sx={{ marginLeft: '5px', marginRight: '5px', textTransform: 'none' }}>
        {lable}
      </Button>
    </InfoComponent>
  );
};


export default CustomButton;
